"use strict";

import Pqp from "../../3x1010/Pqp";
import PageCommon from "../PageCommon";

import Globals from "../../Globals.js";

export default class Profile extends PageCommon {
    constructor(props) {
        super();
        this.data = {};
        this.subscriptionType = [
            {
                type: "1",
                name: "Free Trial",
            },
            {
                type: "2",
                name: "Standard",
            },
            {
                type: "4",
                name: "Pro",
            },
            {
                type: "5",
                name: "Enterprise",
            },
        ];
        this.tracks = null;
        this.artists = null;
        this.countries = null;
        this.paymentUrl = {
            return_url_ok: `${window.location.origin}/thank-you?payment=OK`,
            return_url_err: `${window.location.origin}/profile?payment=ERROR`,
        };
    }
    init({ user, tracks, artists, countries }) {
        super.init();
        if (user) {
            user.subscriptions.sort((a, b) => a.dt1 - b.dt1);
        }
        this.data = user;
        this.tracks = tracks;
        this.artists = artists;
        this.countries = countries;
    }

    set(object) {
        this.data = Object.keys(this.data).map((field) => (this.data[field] = object[field]));
    }

    get() {
        return this.data;
    }

    showPage({ payment }) {
        if (payment) {
            const modal = "#profileUpdateStatusModal";
            document.querySelector(`${modal} .medium-title`).textContent = "Subscription";
            if (payment === "OK") {
                document.querySelector(`${modal} .message`).textContent = "Payment OK";
            } else {
                document.querySelector(`${modal} .message`).textContent = "Payment ERROR";
            }
            jQuery(modal).modal("show");
            setTimeout(() => jQuery(modal).modal("hide"), 3000);
        }
        this.renderPage();
        this.setupEvents();
    }

    setupEvents() {
        const _this = this;
        Array.from(document.querySelectorAll(".user-main-info .btn-edit")).map((button) => {
            button.addEventListener("click", () => {
                _this.updateEditModal();
            });
        });
        document.querySelector(".user-main-info .wrapper-img").addEventListener("click", () => {
            _this.updateEditModal();
        });

        const modalId = "#profileEditModal";
        const modal = document.querySelector(modalId);
        modal.querySelector(".save").addEventListener("click", () => {
            _this.data.first_name = modal.querySelector(".user-name").value;
            _this.data.last_name = modal.querySelector(".user-surname").value;
            _this.sendUpdateProfile();
        });
        modal.querySelector(".file-input").addEventListener("change", (event) => {
            const preview = modal.querySelector(".imagePreview");
            const file = event.target.files[0];
            this.avatarFile = file;
            const reader = new FileReader();
            reader.onload = (event) => {
                preview.style.backgroundImage = `url('${event.target.result}')`;
                this.data.avatar = event.target.result;
            };
            reader.readAsDataURL(file);
        });

        Array.from(document.querySelectorAll(".form-control")).map((item) => {
            if (item.tagName === "INPUT") {
                item.addEventListener("keyup", (event) => {
                    event.target.parentElement.style.color = "";
                    if (event.target.value === "" && event.target.required) {
                        event.target.parentElement.style.color = "red";
                    }
                });
            } else if (item.tagName === "SELECT") {
                item.addEventListener("change", (event) => {
                    event.target.parentElement.style.color = "";
                    if (event.target.value === "" && event.target.required) {
                        event.target.parentElement.style.color = "red";
                    }
                });
            }
        });

        document.querySelector(".user-company-info .save").addEventListener("click", (event) => {
            event.preventDefault();

            _this.data.social.youtube = document.querySelector(".social-block .social-youtube input").value;
            _this.data.social.facebook = document.querySelector(".social-block .social-facebook input").value;
            _this.data.social.instagram = document.querySelector(".social-block .social-instagram input").value;
            _this.data.social.twitch = document.querySelector(".social-block .social-twitch input").value;
            _this.data.social.twitter = document.querySelector(".social-block .social-twitter input").value;
            _this.data.social.tiktok = document.querySelector(".social-block .social-tiktok input").value;

            const company = document.querySelector(".user-company-info");
            _this.data.is_company = company.querySelector(".account-type select").value === "company" ? 1 : 0;
            _this.data.cod_fisc = company.querySelector(".personal-code input").value;
            _this.data.billing.address = company.querySelector(".company-address input").value;
            _this.data.billing.zip = company.querySelector(".company-zipcode input").value;
            _this.data.billing.city = company.querySelector(".company-city input").value;
            _this.data.billing.country = company.querySelector(".company-country select").value;
            _this.data.company.name = company.querySelector(".company-name input").value;
            _this.data.company.vat = company.querySelector(".company-vat input").value;
            _this.data.company.fe_code = company.querySelector(".company-code input").value;
            _this.data.company.pec = company.querySelector(".company-pec input").value;
            let errorFlag = false;
            if (_this.data.billing.country === "") {
                company.querySelector(".company-country").style.color = "red";
                errorFlag = true;
            }
            if (_this.data.is_company) {
                if (_this.data.company.name === "") {
                    company.querySelector(".company-name").style.color = "red";
                    errorFlag = true;
                }
                if (_this.data.is_italy || _this.data.is_eurozone) {
                    if (_this.data.billing.address === "") {
                        company.querySelector(".company-address").style.color = "red";
                        errorFlag = true;
                    }
                    if (_this.data.billing.zip === "") {
                        company.querySelector(".company-zipcode").style.color = "red";
                        errorFlag = true;
                    }
                    if (_this.data.billing.city === "") {
                        company.querySelector(".company-city").style.color = "red";
                        errorFlag = true;
                    }
                    if (_this.data.company.vat === "") {
                        company.querySelector(".company-vat").style.color = "red";
                        errorFlag = true;
                    }
                }
                if (_this.data.is_italy) {
                    if (_this.data.company.fe_code === "") {
                        company.querySelector(".company-code").style.color = "red";
                        errorFlag = true;
                    }
                    if (_this.data.company.pec === "") {
                        company.querySelector(".company-pec").style.color = "red";
                        errorFlag = true;
                    }
                }
            }
            if (!errorFlag) {
                _this.sendUpdateProfile();
            } else {
                return false;
            }
        });
    }

    renderPage() {
        this.renderDetails();
        this.renderCompany();
        this.renderSubscriptions();
        this.renderLicenses();
        this.renderDownloads();
    }

    renderDetails() {
        const detail = document.querySelector(".user-main-info");
        const image = detail.querySelector(".wrapper-img");
        const name = detail.querySelector(".user-name");
        const email = detail.querySelector(".user-email");

        name.textContent = `${this.data.first_name} ${this.data.last_name}`;
        email.textContent = this.data.email;

        if (image.querySelector("img")) {
            image.querySelector("img").src = this.data.avatar;
        } else {
            const imageEl = new Image();
            imageEl.src = this.data.avatar;
            image.appendChild(imageEl);
        }

        // ---

        const social_block = document.querySelector(".social-block");
        social_block.querySelector(".social-youtube input").value = this.data.social.youtube;
        social_block.querySelector(".social-facebook input").value = this.data.social.facebook;
        social_block.querySelector(".social-instagram input").value = this.data.social.instagram;
        social_block.querySelector(".social-twitch input").value = this.data.social.twitch;
        social_block.querySelector(".social-twitter input").value = this.data.social.twitter;
        social_block.querySelector(".social-tiktok input").value = this.data.social.tiktok;

        // ---

    }

    renderCompany() {
        const company = document.querySelector(".user-company-info");
        const accountType = company.querySelector(".account-type select");
        const personalCode = company.querySelector(".personal-code input");
        const companyAddress = company.querySelector(".company-address input");
        const companyZipcode = company.querySelector(".company-zipcode input");
        const companyCity = company.querySelector(".company-city input");
        const companyCountry = company.querySelector(".company-country select");
        const companyName = company.querySelector(".company-name input");
        const companyVat = company.querySelector(".company-vat input");
        const companyCode = company.querySelector(".company-code input");
        const companyPec = company.querySelector(".company-pec input");

        this.countries.map((country) => {
            const option = document.createElement("option");
            option.value = country.ID;
            option.textContent = country.Name;
            companyCountry.appendChild(option);
        });

        this.handleFields();

        accountType.value = this.data.is_company ? "company" : "private";
        personalCode.value = this.data.cod_fisc;
        companyAddress.value = this.data.billing.address;
        companyZipcode.value = this.data.billing.zip;
        companyCity.value = this.data.billing.city;
        companyCountry.value = this.data.billing.country;
        companyName.value = this.data.company.name;
        companyVat.value = this.data.company.vat;
        companyCode.value = this.data.company.fe_code;
        companyPec.value = this.data.company.pec;

        accountType.addEventListener("change", (event) => {
            this.data.is_company = event.currentTarget.value === "company" ? 1 : 0;
            this.handleFields();
        });
        companyCountry.addEventListener("change", (event) => {
            if (event.currentTarget.value) {
                const country = this.countries.filter((item) => item.ID == event.currentTarget.value)[0];
                if (country) {
                    this.data.is_italy = country.Name === "Italy" ? 1 : 0;
                    this.data.is_eurozone = country.euro_zone ? 1 : 0;
                    this.handleFields();
                } else {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cProfile - Can't find country", "color: red");
                }
            }
        });
    }

    handleFields() {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("%cProfile - Handle data changed", "color: orange", this.data);
        const company = document.querySelector(".user-company-info");
        company.querySelector(".account-type").style.display = "none";
        company.querySelector(".personal-code").style.display = "none";
        company.querySelector(".company-address").style.display = "none";
        company.querySelector(".company-address .required").style.display = "none";
        company.querySelector(".company-address input").removeAttribute("required");
        company.querySelector(".company-zipcode").style.display = "none";
        company.querySelector(".company-zipcode .required").style.display = "none";
        company.querySelector(".company-zipcode input").removeAttribute("required");
        company.querySelector(".company-city").style.display = "none";
        company.querySelector(".company-city .required").style.display = "none";
        company.querySelector(".company-city input").removeAttribute("required");
        company.querySelector(".company-country").style.display = "none";
        company.querySelector(".company-country select").setAttribute("required", true);
        company.querySelector(".company-name").style.display = "none";
        company.querySelector(".company-name input").removeAttribute("required");
        company.querySelector(".company-vat").style.display = "none";
        company.querySelector(".company-vat input").removeAttribute("required");
        company.querySelector(".company-code").style.display = "none";
        company.querySelector(".company-code input").removeAttribute("required");
        company.querySelector(".company-pec").style.display = "none";
        company.querySelector(".company-pec input").removeAttribute("required");
        company.querySelector(".company-block").style.display = "";
        if (this.data.is_company && this.data.is_italy) {
            company.querySelector(".account-type").style.display = "";
            company.querySelector(".company-address").style.display = "";
            company.querySelector(".company-address .required").style.display = "";
            company.querySelector(".company-address input").setAttribute("required", true);
            company.querySelector(".company-zipcode").style.display = "";
            company.querySelector(".company-zipcode .required").style.display = "";
            company.querySelector(".company-zipcode input").setAttribute("required", true);
            company.querySelector(".company-city").style.display = "";
            company.querySelector(".company-city .required").style.display = "";
            company.querySelector(".company-city input").setAttribute("required", true);
            company.querySelector(".company-country").style.display = "";
            company.querySelector(".company-name").style.display = "";
            company.querySelector(".company-name input").setAttribute("required", true);
            company.querySelector(".company-vat").style.display = "";
            company.querySelector(".company-vat input").setAttribute("required", true);
            company.querySelector(".company-code").style.display = "";
            company.querySelector(".company-code input").setAttribute("required", true);
            company.querySelector(".company-pec").style.display = "";
            company.querySelector(".company-pec input").setAttribute("required", true);
            this.data.cod_fisc = "";
        } else if (this.data.is_company && this.data.is_eurozone) {
            company.querySelector(".account-type").style.display = "";
            company.querySelector(".company-address").style.display = "";
            company.querySelector(".company-address .required").style.display = "";
            company.querySelector(".company-address input").setAttribute("required", true);
            company.querySelector(".company-zipcode").style.display = "";
            company.querySelector(".company-zipcode .required").style.display = "";
            company.querySelector(".company-zipcode input").setAttribute("required", true);
            company.querySelector(".company-city").style.display = "";
            company.querySelector(".company-city .required").style.display = "";
            company.querySelector(".company-city input").setAttribute("required", true);
            company.querySelector(".company-country").style.display = "";
            company.querySelector(".company-name").style.display = "";
            company.querySelector(".company-name input").setAttribute("required", true);
            company.querySelector(".company-vat").style.display = "";
            company.querySelector(".company-vat input").setAttribute("required", true);
            this.data.cod_fisc = "";
            this.data.company.fe_code = "";
            this.data.company.pec = "";
        } else if (this.data.is_company) {
            company.querySelector(".account-type").style.display = "";
            company.querySelector(".company-address").style.display = "";
            company.querySelector(".company-zipcode").style.display = "";
            company.querySelector(".company-city").style.display = "";
            company.querySelector(".company-country").style.display = "";
            company.querySelector(".company-name").style.display = "";
            company.querySelector(".company-name input").setAttribute("required", true);
            this.data.cod_fisc = "";
            this.data.company.vat = "";
            this.data.company.fe_code = "";
            this.data.company.pec = "";
        } else if (this.data.is_italy) {
            company.querySelector(".account-type").style.display = "";
            company.querySelector(".personal-code").style.display = "";
            company.querySelector(".company-address").style.display = "";
            company.querySelector(".company-zipcode").style.display = "";
            company.querySelector(".company-city").style.display = "";
            company.querySelector(".company-country").style.display = "";
            company.querySelector(".company-block").style.display = "none";
            this.data.company.name = "";
            this.data.company.vat = "";
            this.data.company.fe_code = "";
            this.data.company.pec = "";
        } else {
            company.querySelector(".account-type").style.display = "";
            company.querySelector(".company-address").style.display = "";
            company.querySelector(".company-zipcode").style.display = "";
            company.querySelector(".company-city").style.display = "";
            company.querySelector(".company-country").style.display = "";
            company.querySelector(".company-block").style.display = "none";
            this.data.cod_fisc = "";
            this.data.company.name = "";
            this.data.company.vat = "";
            this.data.company.fe_code = "";
            this.data.company.pec = "";
        }
    }

    renderSubscriptions() {
        const subscriptions = document.querySelector(".user-sub-info");

        const subActive = subscriptions.querySelector(".active-sub");
        subActive.querySelector("button").addEventListener("click", () => {
            window.location.href = "/pricing";
        });

        const subExpire = subscriptions.querySelector(".expire-sub");
        let lastDateExpired = 0;
        if (this.data.autorenew.active) {
            const token = this.getCookie("user_token");
            let url = `${Globals.WS_URL}?mode=UNSUBSCRIBE&token=${token}&return_url=` + window.location.href;
    
            subExpire.querySelector("button").addEventListener("click", () => {
                if (confirm("Are you sure you want to unsubscribe from Sounzone?")) {
                    window.location.href = url;
                }
            });
        } else {
            subExpire.querySelector("label").innerHTML = "Subscription expiration date";
            subExpire.querySelector("button").style.display = "none";
        }

        const subsList = subscriptions.querySelector(".subs-list");

        this.data.subscriptions.map((subscription) => {
            //const type = this.subscriptionType.filter((type) => type.type === subscription.type)[0];
            const type = this.subscriptionType.filter((type) => type.type === "" + subscription.type)[0]; // castato a stringa
            if (type && type.name) {
                const dt1 = this.extractDate(subscription.dt1);
                const dt2 = this.extractDate(subscription.dt2);

                if (dt2 > new Date()) {
                    subActive.querySelector(".subs-name").textContent = type.name;
                    subActive.style.display = "block";
                    subExpire.querySelector(".subs-expire").textContent = this.formatDate(dt2);
                    subExpire.style.display = "block";
                } else {
                    /*
                    if (lastDateExpired === 0 || dt2 < lastDateExpired) {
                        lastDateExpired = dt2;
                        subExpire.querySelector(".subs-expire").textContent = this.formatDate(dt2);
                        subExpire.style.display = "block";
                    }
                    */
                }

                const subscriptionItem = document.querySelector("#model-profile-subscription-item .subs-item").cloneNode(true);
                subscriptionItem.querySelector(".name").textContent = type.name;
                if (dt2 > new Date()) {
                    subscriptionItem.querySelector(".expired").textContent = `valid until ${this.formatDate(dt2)}`;
                } else {
                    subscriptionItem.querySelector(".expired").textContent = `expired ${this.formatDate(dt2)}`;
                }
                subsList.appendChild(subscriptionItem);
            }
        });
    }

    renderLicenses() {
        const licenses = document.querySelector(".licenses-history");
        const licensesList = licenses.querySelector(".tracks-list .tracks-list-body");

        this.data.orders.map((license) => {
            const licenseItem = document.querySelector("#model-profile-license-item .track-item").cloneNode(true);

            licenseItem.querySelector(".order-number").textContent = license.id;
            licenseItem.querySelector(".order-tracks").textContent = license.tracks > 1 ? `${license.tracks} Tracks` : `${license.tracks} Track`;
            licenseItem.querySelector(".order-license-type").textContent = license.license;
            licenseItem.querySelector(".order-price").textContent = `€ ${license.tot}`;
            licenseItem.querySelector(".tl-actions a").href = license.pdf;

            licensesList.appendChild(licenseItem);
        });
    }

    renderDownloads() {
        const downloads = document.querySelector(".downloads-history");
        const downloadsList = downloads.querySelector(".tracks-list .tracks-list-body");

        this.data.downloads.map((download) => {
            const downloadItem = document.querySelector("#model-profile-download-item .track-item").cloneNode(true);

            const track = this.tracks.get({ id: download });

            if (track) {
                downloadItem.querySelector(".tl-track").textContent = track.data.Name;
                track.setupArtistsObject(this.artists);
                if (track.data.Artists.length > 0) {
                    if (track.data.Artists[0]) {
                        downloadItem.querySelector(".tl-artist").href = this.setUrlParams("/artist/" + this._normalizza_track_prop(track.data.Artists[0].data.Name), [
                            { key: "id", value: track.data.Artists[0].data.ID },
                            { key: "format", value: this._normalizza_track_prop(track.data.Artists[0].data.Format) },
                        ]);
                    }
                    downloadItem.querySelector(".tl-artist").innerHTML = track.data.Artists.map((artist) => {
                        if (artist) {
                            return artist.get().Name;
                        }
                        return "";
                    }).join(", ");
                }
                downloadItem.querySelector(".tl-length").textContent = track.data.MP3.LengthFMT;

                downloadItem.querySelector(".dropdown .dropdown-menu .download").href = track.data.MP3.Url;

                downloadItem.querySelector(".dropdown .dropdown-menu .match-video").addEventListener("click", (event) => {
                    event.preventDefault();
                    if (Pqp.isMobile()) {
                        window.location.href = "/match-video-mobile";
                    } else {
                        track.emitEvent("match_video_to_track", { detail: { track: track.data } });
                    }
                });

                downloadsList.appendChild(downloadItem);
            }
        });
    }

    updateEditModal() {
        const modalId = "#profileEditModal";
        const modal = document.querySelector(modalId);
        const image = modal.querySelector(`.user-main-info .wrapper-img`);
        const name = modal.querySelector(`input.user-name`);
        const surname = modal.querySelector(`input.user-surname`);

        setTimeout(() => {
            name.value = this.data.first_name;
            surname.value = this.data.last_name;
            image.querySelector(".imagePreview").style.backgroundImage = `url(${this.data.avatar})`;
        }, 100);
    }

    // sendUpdateProfile() {
    //     const token = this.getCookie("user_token");
    //     const modalId = "#profileUpdateStatusModal";
    //     this.showUpdateStatusModal();
    //     jQuery(modalId).modal("show");
    //     if (token) {
    //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update");
    //         let url = `${Globals.WS_URL}?mode=USERDATA.UPDATE&token=${token}&user_data=${JSON.stringify(this.data)}`;
    //         fetch(url)
    //             .then(this.handleResponse)
    //             .then((result) => {
    //                 if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
    //                 if (result.updated) {
    //                     if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update OK");
    //                     this.userLogged = result.user;
    //                     this.renderDetails();
    //                     this.renderCompany();
    //                     this.showUpdateStatusModal("Updated");
    //                     setTimeout(() => jQuery(modalId).modal("hide"), 2000);
    //                 } else {
    //                     if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update ERROR");
    //                     this.showUpdateStatusModal("ERROR");
    //                 }
    //             })
    //             .catch((error) => Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message }));
    //     } else {
    //         if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile Update - Token NOT present");
    //     }
    // }

    sendUpdateProfile() {
        const token = this.getCookie("user_token");
        const modalId = "#profileUpdateStatusModal";
        this.showUpdateStatusModal("");
        jQuery(modalId).modal("show");
        if (token) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update");
            const data = {
                token,
                user_data: JSON.stringify({
                    ID: this.data.ID,
                    first_name: this.data.first_name,
                    last_name: this.data.last_name,
                    is_company: this.data.is_company,
                    cod_fisc: this.data.cod_fisc,
                    billing: {
                        address: this.data.billing.address,
                        zip: this.data.billing.zip,
                        city: this.data.billing.city,
                        country: this.data.billing.country,
                    },
                    company: {
                        name: this.data.company.name,
                        vat: this.data.company.vat,
                        fe_code: this.data.company.fe_code,
                        pec: this.data.company.pec,
                    },
                    social: {
                        youtube: this.data.social.youtube,
                        facebook: this.data.social.facebook,
                        instagram: this.data.social.instagram,
                        twitch: this.data.social.twitch,
                        twitter: this.data.social.twitter,
                        tiktok: this.data.social.tiktok,
                    },
                }),
                avatar: this.avatarFile,
            };

            let url = `${Globals.WS_URL}?mode=USERDATA.UPDATE`;

            const formData = new FormData();

            for (const name in data) {
                formData.append(name, data[name]);
            }

            const args = {
                method: "POST",
                header: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: formData,
            };

            fetch(url, args)
                .then(this.handleResponse)
                .then((result) => {
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                    if (result.updated) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update OK");
                        this.userLogged = result.user;
                        this.renderDetails();
                        this.renderCompany();
                        this.showUpdateStatusModal("Updated");
                        setTimeout(() => jQuery(modalId).modal("hide"), 2000);
                    } else {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Update ERROR");
                        this.showUpdateStatusModal("ERROR");
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile Update - Token NOT present");
        }
    }

    showUpdateStatusModal(text) {
        const modalId = "#profileUpdateStatusModal";
        const modal = document.querySelector(modalId);
        const message = modal.querySelector(`.message`);
        message.textContent = "";
        if (text) {
            jQuery(`${modalId} .js-preloader`).hide();
            message.textContent = text;
        } else {
            jQuery(`${modalId} .js-preloader`).show();
        }
    }

    buyFreeTrial() {
        const token = this.getCookie("user_token");
        let url = `${Globals.WS_URL}?mode=PAYMENT&token=${token}&return_url_ok=${this.paymentUrl.return_url_ok}&return_url_err=${this.paymentUrl.return_url_err}&output=1&contract=1.T`;
        window.location.href = url;
    }

    buySubscription(forceToken) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Profile - Subscription Link Setup");
        if (this.data || forceToken) {
            const token = this.getCookie("user_token") || forceToken;
            let basePaymentUrl = `${Globals.WS_URL}?mode=PAYMENT&token=${token}&return_url_ok=${this.paymentUrl.return_url_ok}&return_url_err=${this.paymentUrl.return_url_err}&output=1`;
            Array.from(document.querySelectorAll(".price-card .payment-send")).map((link) => {
                let url = basePaymentUrl;
                if (link.dataset.cc) {
                    if (link.dataset.cc === "1") {
                        link.closest(".cards-group").remove();
                        return false;
                    } else {
                        url += `&contract=${link.dataset.cc}`;
                    }
                    link.href = url;
                    link.removeAttribute("data-toggle");
                }
            });
        } else {
            Array.from(document.querySelectorAll(".price-card .payment-send")).map((link) => {
                if (link.dataset.cc) {
                    link.href = "#loginModal";
                    link.dataset.toggle = "modal";
                }
            });
        }
    }

    dispose() {
        this.data = {};
    }
}
